import ApplicationAdapter from 'eflex/adapters/application';

export default class KineticPartRevAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
